const animateTable = (table) => {
  if (!table) throw Error('No table found');

  table.classList.add('is_fading');
  setTimeout(() => table.classList.remove('is_fading'), 500);
};

export default animateTable;
